// ─────────────────────────────────────────────
//  SITE CONTENT
//  Edit this file to update general site info:
//  company name, tagline, contact details, about text, etc.
// ─────────────────────────────────────────────

const siteContent = {
  company: {
    name: 'Insight Integrated',
    tagline: 'Building Intelligence, Seamlessly Integrated',
    email: 'info@insight-integrated.com',
    website: 'insight-integrated.com',
    responseTime: 'We typically respond within 1 business day.',
    // phone: '+1 (555) 000-0000',  // uncomment and add when ready
  },

  hero: {
    eyebrow: 'Integration & Consulting',
    heading: ['Building', 'Intelligence,', 'Seamlessly Integrated'],
    accentWord: 'Intelligence,',
    subtext:
      'Insight Integrated delivers expert integration services and consulting for data centers and commercial facilities — specializing in BMS, BAS, and EPMS systems.',
  },

  about: {
    sectionLabel: 'Who We Are',
    heading: 'Integrated Solutions for Complex Facilities',
    subtext:
      'We bring deep technical expertise to the systems that keep critical infrastructure running — intelligently and efficiently.',
    body: [
      'Insight Integrated was founded on the belief that building automation and power management systems should work together — not in silos. Our consultants bring hands-on experience across a broad range of facilities, from hyperscale data centers to complex commercial campuses.',
      "We partner with owners, engineers, and general contractors from early design through commissioning and ongoing optimization, ensuring your facility's intelligent systems are fully integrated, scalable, and future-ready.",
    ],
    expertise: [
      'Systems integration for mission-critical environments',
      'End-to-end project consulting & commissioning',
      'Cross-platform BMS, BAS & EPMS interoperability',
      'Data center infrastructure management (DCIM) support',
      'Vendor-neutral solutions tailored to your facility',
    ],
  },

  contact: {
    sectionLabel: 'Get In Touch',
    heading: "Let's Talk About Your Project",
    subtext:
      "Whether you're planning a new facility, upgrading existing systems, or need a vendor-neutral integration consultant — we're ready to help.",
    serviceOptions: [
      'Systems Integration',
      'Building Automation (BMS/BAS)',
      'EPMS Consulting',
      'Data Center Solutions',
      'Project Commissioning',
      'Ongoing Support',
      'General Inquiry',
    ],
  },

  footer: {
    copyrightEntity: 'Insight Integrated LLC',
  },
};

export default siteContent;
